module.exports = "/_next/static/images/f0b67d2d679830e97fcc37a89d591823-Nubank_HickDuarte_55193_md.jpg";